module.exports = __webpack_public_path__ + "img/loader.26ef8bb4.gif";